/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BankAccountCell_bankAccount$ref = any;
type CashbackCell_cashback$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FastCashContainer_fastCash$ref: FragmentReference;
declare export opaque type FastCashContainer_fastCash$fragmentType: FastCashContainer_fastCash$ref;
export type FastCashContainer_fastCash = {|
  +id: string,
  +lifetimeCash: number,
  +availableCash: number,
  +pendingCash: number,
  +specialCashbackRate: {|
    +id: number,
    +fastCashId: string,
    +userId: string,
    +comment: string,
    +state: string,
    +cashbackRate: string,
    +createdAt: string,
    +updatedAt: string,
    +deletedAt: string,
  |},
  +firstOnboardedAt: ?string,
  +blockedState: string,
  +transactionsData: {|
    +transactionsCount: number,
    +depositsAmount: number,
    +expensesAmount: number,
  |},
  +cashbacksData: {|
    +netCashbacksAmount: number,
    +spentCashbacksAmount: number,
    +earnedCashbacksAmount: number,
    +refundCashbacksAmount: number,
  |},
  +integrationItems: ?$ReadOnlyArray<{|
    +id: string,
    +institutionName: ?string,
    +itemId: ?string,
    +state: ?string,
    +errorCode: ?string,
    +accountOnboardedAt: ?string,
  |}>,
  +user: {|
    +email: ?string,
    +referrer: ?{|
      +fullName: ?string,
      +auth0Id: ?string,
    |},
    +invitedUsers: ?$ReadOnlyArray<{|
      +auth0Id: ?string,
      +fullName: ?string,
    |}>,
  |},
  +cashbacks: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +amount: number,
    +state: ?string,
    +date: any,
    +quarantinedReason: ?string,
    +availableStates: ?$ReadOnlyArray<string>,
    +storeId: string,
    +place: string,
    +$fragmentRefs: CashbackCell_cashback$ref,
  |}>,
  +bankAccounts: $ReadOnlyArray<{|
    +id: string,
    +name: ?string,
    +duplicationState: string,
    +plaidAccountId: string,
    +availableDuplicationStates: ?$ReadOnlyArray<string>,
    +bankAccountsWithMask: ?$ReadOnlyArray<{|
      +id: string
    |}>,
    +integrationItem: {|
      +institutionName: ?string
    |},
    +$fragmentRefs: BankAccountCell_bankAccount$ref,
  |}>,
  +checkIns: $ReadOnlyArray<{|
    +id: string,
    +createdAt: string,
  |}>,
  +latestMembershipState: ?string,
  +$refType: FastCashContainer_fastCash$ref,
|};
export type FastCashContainer_fastCash$data = FastCashContainer_fastCash;
export type FastCashContainer_fastCash$key = {
  +$data?: FastCashContainer_fastCash$data,
  +$fragmentRefs: FastCashContainer_fastCash$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "afterDate",
  "variableName": "afterDate"
},
v4 = {
  "kind": "Variable",
  "name": "beforeDate",
  "variableName": "beforeDate"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutionName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auth0Id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDate",
      "type": "Date!"
    },
    {
      "kind": "RootArgument",
      "name": "beforeDate",
      "type": "Date!"
    },
    {
      "kind": "RootArgument",
      "name": "stateEq",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "bankAccountIdEq",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "storeIdEq",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "integrationItemIdEq",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "nameCont",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "byMerchantNames",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "nameNotIContAll",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FastCashContainer_fastCash",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lifetimeCash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableCash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingCash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpecialCashback",
      "kind": "LinkedField",
      "name": "specialCashbackRate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fastCashId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cashbackRate",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deletedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstOnboardedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blockedState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/),
        {
          "kind": "Variable",
          "name": "bankAccountIdEq",
          "variableName": "bankAccountIdEq"
        },
        (v4/*: any*/),
        {
          "kind": "Variable",
          "name": "byMerchantNames",
          "variableName": "byMerchantNames"
        },
        {
          "kind": "Variable",
          "name": "integrationItemIdEq",
          "variableName": "integrationItemIdEq"
        },
        {
          "kind": "Variable",
          "name": "nameCont",
          "variableName": "nameCont"
        },
        {
          "kind": "Variable",
          "name": "nameNotIContAll",
          "variableName": "nameNotIContAll"
        },
        {
          "kind": "Variable",
          "name": "stateEq",
          "variableName": "stateEq"
        },
        {
          "kind": "Variable",
          "name": "storeIdEq",
          "variableName": "storeIdEq"
        }
      ],
      "concreteType": "TransactionsData",
      "kind": "LinkedField",
      "name": "transactionsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transactionsCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depositsAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expensesAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v5/*: any*/),
      "concreteType": "CashbacksData",
      "kind": "LinkedField",
      "name": "cashbacksData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "netCashbacksAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spentCashbacksAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "earnedCashbacksAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refundCashbacksAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationItem",
      "kind": "LinkedField",
      "name": "integrationItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountOnboardedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "referrer",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "invitedUsers",
          "plural": true,
          "selections": [
            (v8/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v5/*: any*/),
      "concreteType": "Cashback",
      "kind": "LinkedField",
      "name": "cashbacks",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quarantinedReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availableStates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "storeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "place",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CashbackCell_cashback"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BankAccount",
      "kind": "LinkedField",
      "name": "bankAccounts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duplicationState",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plaidAccountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availableDuplicationStates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BankAccount",
          "kind": "LinkedField",
          "name": "bankAccountsWithMask",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationItem",
          "kind": "LinkedField",
          "name": "integrationItem",
          "plural": false,
          "selections": [
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BankAccountCell_bankAccount"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v5/*: any*/),
      "concreteType": "CheckIn",
      "kind": "LinkedField",
      "name": "checkIns",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestMembershipState",
      "storageKey": null
    }
  ],
  "type": "FastCash"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e389fefbf1472db124140fe2ae5d34ce';

module.exports = node;
